<template>
  <div class="px-3 py-3 mb-5 col-24 col-md-11">
    <div class="col d-column">
      <h1 class="title pt-2 mb-0" v-text="$ml.get('integration')">
        Integração
      </h1>
      <h1 class="title">
        <span
          class="pb-2"
          v-text="$ml.get('receiveNotificationsAboutNewReports')"
          >Receba notificações sobre novos relatórios diretamente no seu slack e
          teams.</span
        >
      </h1>

      <div class="accordion" role="tablist">
        <!-- Gat -->
        <b-card no-body v-if="integrationList.includes('gat')" class="mb-2">
          <div class="card-header p-1" header-tag="header" role="tab">
            <h6
              block
              v-b-toggle.accordion-gat
              variant="info"
              class="p-2 light d-flex justify-content-between align-items-center"
            >
              <font>GAT</font>
              <span class="when-opened">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16 angle-right"
                />
              </span>
              <span class="when-closed">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16"
                />
              </span>
            </h6>
          </div>
          <b-collapse
            id="accordion-gat"
            visible
            accordion="my-accordion"
            role="tabpanel"
            @input="updateRecaptcha('gat')"
          >
            <div class="card-body">
              <form v-on:submit.prevent="">
                <div class="row">
                  <div class="col pr-1">
                    <div class="form-group">
                      <label class="text-muted">GAT Webhooks</label>

                      <div class="">
                        <input
                          type="text"
                          v-model="gat_url"
                          class="form-control"
                          placeholder="https://your-domain.gat.digital/"
                          maxlength="200"
                        />
                        <transition name="fade">
                          <label
                            v-if="integrationGatError && !$v.gat_url.minLength"
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="integrationGatError && !gat_url"
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório</label
                          >
                        </transition>
                        <small class="row"
                          ><font v-text="'Exemplo'"> </font>
                          <a
                            class="ml-1"
                            target="_blank"
                            rel="noopener noreferrer"
                            >https://your-domain.gat.digital</a
                          >
                        </small>
                      </div>

                      <div class="mt-4">
                        <div style="position: relative">
                          <input
                          :type="showGatToken ? 'text' : 'password'"
                            v-model="gat_token"
                            class="form-control"
                            placeholder="Bearer BH7a73ed-f795-2021-962e-da6f579fd7BH"
                            maxlength="45"
                          />
                          <VueCustomTooltip v-show="gat_token?.length" class="login-ico" style="position:absolute">
                            <svg class="ico-20" @click="showGatToken = !showGatToken">
                              <image class="icon-eye" v-show="showGatToken" xlink:href="../../assets/icons/eye-slash.svg" width="20"
                                height="20" />
                                <image class="icon-eye" v-show="!showGatToken" xlink:href="../../assets/icons/eye.svg" width="20"
                                height="20" />
                            </svg>
                          </VueCustomTooltip>
                        </div>
                        <transition name="fade">
                          <label
                            v-if="
                              integrationGatError && !$v.gat_token.minLength
                            "
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="integrationGatError && !gat_token"
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório</label
                          >
                        </transition>
                        <small class="row"
                          ><font
                            v-text="$ml.with('Token').get('questionsAboutUrl')"
                          >
                            Dúvidas sobre token ?</font
                          >
                          <a
                            class="ml-1"
                            href="https://help.gat.digital/pt-BR/articles/5814793-como-obter-a-chave-de-api-gat-core"
                            target="_blank"
                            rel="noopener noreferrer"
                            v-text="$ml.get('clickHereToLearn')"
                          >
                            Saiba mais</a
                          >
                        </small>
                      </div>
                      <div class="mt-4 align-items-center">
                        <label
                          class="text-muted"
                          v-text="$ml.get('gatTagDescription')"
                          >Quais relatórios serão enviados para a plataforma
                          GAT?</label
                        >
                        <b-form-group>
                          <b-form-radio-group v-model="selectedGatIntegration">
                            <b-form-radio
                              class="align-center"
                              v-model="gatIntegrationOpt"
                              :value="{ id: 'all', name: 'all' }"
                              ><span
                                style="line-height: 1.5rem !important"
                                v-text="$ml.get('all')"
                              ></span
                            ></b-form-radio>
                            <b-form-radio
                              class="align-bottom"
                              v-model="gatIntegrationOpt"
                              :value="{ id: 'gat-tag', name: 'gat-tag' }"
                              ><span
                                style="line-height: 1.5rem !important"
                                v-text="$ml.get('gatTagOptDescription')"
                              ></span
                            ></b-form-radio>
                          </b-form-radio-group>
                        </b-form-group>
                        <!-- <div class="mt-3">selectedGatIntegration: <strong>{{ selectedGatIntegration }}</strong></div> -->
                        <!-- <div class="mt-3">gatIntegrationOpt: <strong>{{ gatIntegrationOpt }}</strong></div> -->
                      </div>
                    </div>
                  </div>
                </div>

                <RecaptchaV2 ref="gat-recaptcha" @verify="setRecaptchaToken($event, 'gat-recaptcha')" @expired="tokenCaptcha['gat-recaptcha'] = ''"/>

                <div class="row my-2">
                  <button @click="alterIntegration('gat')" class="btn btnForm" :disabled="!tokenCaptcha['gat-recaptcha']">
                    <Spinner v-show="loadingBtn" />
                    <span v-show="!loadingBtn" v-text="$ml.get('update')"
                      >Atualizar</span
                    >
                  </button>
                  <button
                    @click="removeIntegration('gat')"
                    :disabled="!gat_url || !gat_token || !tokenCaptcha['gat-recaptcha']"
                    class="btn btn-outline-extra m-0 ml-2"
                  >
                    <Spinner v-show="loadingRemoveBtn" :color="'pink'" />
                    <span v-show="!loadingRemoveBtn" v-text="$ml.get('remove')"
                      >Excluir</span
                    >
                  </button>
                </div>
              </form>
            </div>
          </b-collapse>
        </b-card>
        <!-- Slack -->
        <b-card no-body v-if="integrationList.includes('slack')" class="mb-2">
          <div class="card-header p-1" header-tag="header" role="tab">
            <h6
              block
              v-b-toggle.accordion-slack
              variant="info"
              class="p-2 light d-flex justify-content-between align-items-center"
            >
              <font>Slack</font>
              <span class="when-opened">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16 angle-right"
                />
              </span>
              <span class="when-closed">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16"
                />
              </span>
            </h6>
          </div>
          <b-collapse
            id="accordion-slack"
            visible
            accordion="my-accordion"
            role="tabpanel"
            @input="updateRecaptcha('slack')"
          >
            <div class="card-body">
              <form v-on:submit.prevent="">
                <div class="row">
                  <div class="col pr-1">
                    <div class="form-group">
                      <label class="text-muted"
                        >URL Slack Incoming Webhooks</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        placeholder="https://hooks.slack.com/services"
                        v-model="slack_url"
                        maxlength="250"
                      />
                      <transition name="fade">
                        <label
                          v-if="
                            integrationSlackError && !$v.slack_url.minLength
                          "
                          class="lblError"
                          v-text="$ml.get('theWebhookIsNotValid')"
                          >O webhook não é válido!</label
                        >
                        <label
                          v-else-if="integrationSlackError && !slack_url"
                          class="lblError"
                          v-text="$ml.get('requiredField')"
                        >
                          Campo obrigatório
                        </label>
                      </transition>
                      <small class="row"
                        ><font v-text="$ml.get('anyQuestionsAboutIntegration')"
                          >Dúvidas sobre essa integração?</font
                        >
                        <a
                          class="ml-1"
                          href="https://api.slack.com/messaging/webhooks"
                          target="_blank"
                          rel="noopener noreferrer"
                          v-text="$ml.get('clickHereToLearn')"
                          >Saiba mais</a
                        >
                      </small>
                    </div>
                  </div>
                </div>

                <RecaptchaV2 ref="slack-recaptcha" @verify="setRecaptchaToken($event, 'slack-recaptcha')" @expired="tokenCaptcha['slack-recaptcha'] = ''"/>

                <div class="row my-2">
                  <button
                    @click="alterIntegration('slack')"
                    class="btn btnForm m-0"
                    :disabled="!tokenCaptcha['slack-recaptcha']"
                  >
                    <Spinner v-show="loadingBtn" />
                    <span v-show="!loadingBtn" v-text="$ml.get('update')"
                      >Atualizar</span
                    >
                  </button>
                  <button
                    @click="removeIntegration('slack')"
                    :disabled="!slack_url || !tokenCaptcha['slack-recaptcha']"
                    class="btn btn-outline-extra m-0 ml-2"
                  >
                    <Spinner v-show="loadingRemoveBtn" :color="'pink'" />
                    <span v-show="!loadingRemoveBtn" v-text="$ml.get('remove')"
                      >Remover</span
                    >
                  </button>
                </div>
              </form>
            </div>
          </b-collapse>
        </b-card>
        <!-- Teams -->
        <b-card no-body v-if="integrationList.includes('teams')" class="mb-2">
          <div class="card-header p-1" header-tag="header" role="tab">
            <h6
              block
              v-b-toggle.accordion-teams
              variant="info"
              class="p-2 light d-flex justify-content-between align-items-center"
            >
              <font>Teams</font>
              <span class="when-opened">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16 angle-right"
                />
              </span>
              <span class="when-closed">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16"
                />
              </span>
            </h6>
          </div>
          <b-collapse
            id="accordion-teams"
            visible
            accordion="my-accordion"
            role="tabpanel"
            @input="updateRecaptcha('teams')"
          >
            <div class="card-body">
              <form v-on:submit.prevent="">
                <div class="row">
                  <div class="col pr-1">
                    <div class="form-group">
                      <label class="text-muted"
                        >URL Microsoft Teams Incoming Webhooks</label
                      >
                      <input
                        type="text"
                        v-model="teams_url"
                        class="form-control"
                        placeholder="https://outlook.office.com/webhook..."
                        maxlength="250"
                      />
                      <transition name="fade">
                        <label
                          v-if="
                            integrationTeamsError && !$v.teams_url.minLength
                          "
                          class="lblError"
                          v-text="$ml.get('theWebhookIsNotValid')"
                          >O webhook não é válido!</label
                        >
                        <label
                          v-else-if="integrationTeamsError && !teams_url"
                          class="lblError"
                          v-text="$ml.get('requiredField')"
                        >
                          Campo obrigatório
                        </label>
                      </transition>
                      <small class="row"
                        ><font v-text="$ml.get('anyQuestionsAboutIntegration')"
                          >Dúvidas sobre essa integração?</font
                        >
                        <a
                          class="ml-1"
                          href="https://docs.microsoft.com/en-us/microsoftteams/platform/webhooks-and-connectors/how-to/add-incoming-webhook"
                          target="_blank"
                          rel="noopener noreferrer"
                          v-text="$ml.get('clickHereToLearn')"
                        >
                          Saiba mais</a
                        >
                      </small>
                    </div>
                  </div>
                </div>

                <RecaptchaV2 ref="teams-recaptcha" @verify="setRecaptchaToken($event, 'teams-recaptcha')" @expired="tokenCaptcha['teams-recaptcha'] = ''"/>

                <div class="row my-2">
                  <button
                    @click="alterIntegration('teams')"
                    class="btn btnForm m-0"
                    :disabled="!tokenCaptcha['teams-recaptcha']"
                  >
                    <Spinner v-show="loadingBtn" />
                    <span v-show="!loadingBtn" v-text="$ml.get('update')"
                      >Atualizar</span
                    >
                  </button>
                  <button
                    @click="removeIntegration('teams')"
                    :disabled="!teams_url || !tokenCaptcha['teams-recaptcha']"
                    class="btn btn-outline-extra m-0 ml-2"
                  >
                    <Spinner v-show="loadingRemoveBtn" :color="'pink'" />
                    <span v-show="!loadingRemoveBtn" v-text="$ml.get('remove')"
                      >Remover</span
                    >
                  </button>
                </div>
              </form>
            </div>
          </b-collapse>
        </b-card>
        <!-- Google Chat -->
        <b-card
          no-body
          v-if="integrationList.includes('google_chat')"
          class="mb-2"
        >
          <div class="card-header p-1" header-tag="header" role="tab">
            <h6
              block
              v-b-toggle.accordion-gChat
              variant="info"
              class="p-2 light d-flex justify-content-between align-items-center"
            >
              <font>Google Chat</font>
              <span class="when-opened">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16 angle-right"
                />
              </span>
              <span class="when-closed">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16"
                />
              </span>
            </h6>
          </div>
          <b-collapse
            id="accordion-gChat"
            visible
            accordion="my-accordion"
            role="tabpanel"
            @input="updateRecaptcha('google-chat')"
          >
            <div class="card-body">
              <form v-on:submit.prevent="">
                <div class="row">
                  <div class="col pr-1">
                    <div class="form-group">
                      <label class="text-muted"
                        >URL Google Chat Incoming Webhooks</label
                      >
                      <input
                        type="text"
                        v-model="gChat_url"
                        class="form-control"
                        placeholder="https://chat.googleapis.com/v1/spaces/bug..."
                        maxlength="250"
                      />
                      <transition name="fade">
                        <label
                          v-if="
                            integrationGChatError && !$v.gChat_url.minLength
                          "
                          class="lblError"
                          v-text="$ml.get('theWebhookIsNotValid')"
                          >O webhook não é válido!
                        </label>
                        <label
                          v-else-if="integrationGChatError && !gChat_url"
                          class="lblError"
                          v-text="$ml.get('requiredField')"
                        >
                          Campo obrigatório
                        </label>
                      </transition>
                      <small class="row">
                        <font v-text="$ml.get('anyQuestionsAboutIntegration')"
                          >Dúvidas sobre essa integração?</font
                        >
                        <a
                          class="ml-1"
                          href="https://developers.google.com/chat/how-tos/webhooks"
                          target="_blank"
                          rel="noopener noreferrer"
                          v-text="$ml.get('clickHereToLearn')"
                        >
                          Saiba mais
                        </a>
                      </small>
                    </div>
                  </div>
                </div>

                <RecaptchaV2 ref="google-chat-recaptcha" @verify="setRecaptchaToken($event, 'google-chat-recaptcha')" @expired="tokenCaptcha['google-chat-recaptcha'] = ''"/>

                <div class="row my-2">
                  <button
                    @click="alterIntegration('google chat')"
                    class="btn btnForm m-0"
                    :disabled="!tokenCaptcha['google-chat-recaptcha']"
                  >
                    <Spinner v-show="loadingBtn" />
                    <span v-show="!loadingBtn" v-text="$ml.get('update')"
                      >Atualizar</span
                    >
                  </button>
                  <button
                    @click="removeIntegration('google chat')"
                    :disabled="!gChat_url || !tokenCaptcha['google-chat-recaptcha']"
                    class="btn btn-outline-extra m-0 ml-2"
                  >
                    <Spinner v-show="loadingRemoveBtn" :color="'pink'" />
                    <span v-show="!loadingRemoveBtn" v-text="$ml.get('remove')"
                      >Remover</span
                    >
                  </button>
                </div>
              </form>
            </div>
          </b-collapse>
        </b-card>
        <!-- Jira -->
        <b-card no-body v-if="integrationList.includes('jira')" class="mb-2">
          <div class="card-header p-1" header-tag="header" role="tab">
            <h6
              block
              v-b-toggle.accordion-jira
              variant="info"
              class="p-2 light d-flex justify-content-between align-items-center"
            >
              <font>Jira Service Manager</font>
              <span class="when-opened">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16 angle-right"
                />
              </span>
              <span class="when-closed">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16"
                />
              </span>
            </h6>
          </div>
          <b-collapse
            id="accordion-jira"
            visible
            accordion="my-accordion"
            role="tabpanel"
            @input="updateRecaptcha('jira')"
          >
            <div class="card-body">
              <form v-on:submit.prevent="">
                <div class="row">
                  <div class="col pr-1">
                    <div class="form-group">
                      <label class="text-muted">Jira Webhooks</label>

                      <div class="">
                        <input
                          type="text"
                          v-model="jira_url"
                          class="form-control"
                          placeholder="https://your-domain.atlassian.net/"
                          maxlength="400"
                        />
                        <transition name="fade">
                          <label
                            v-if="
                              integrationJiraError && !$v.jira_url.minLength
                            "
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="integrationJiraError && !jira_url"
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório
                          </label>
                        </transition>
                        <small class="row"
                          ><font
                            v-text="
                              $ml.with('url Jira').get('questionsAboutUrl')
                            "
                          >
                            Dúvidas sobre url Jira ?</font
                          >
                          <a
                            class="ml-1"
                            href="https://developer.atlassian.com/cloud/jira/service-desk/rest/intro/#authentication-for-other-integrations"
                            target="_blank"
                            rel="noopener noreferrer"
                            v-text="$ml.get('clickHereToLearn')"
                          >
                            Saiba mais</a
                          >
                        </small>
                      </div>

                      <div class="mt-4">
                        <div style="position: relative">
                          <input
                            :type="showJiraKey ? 'text' : 'password'"
                            v-model="jira_key"
                            class="form-control"
                            placeholder="BHIJ"
                            maxlength="400"
                          />
                          <VueCustomTooltip v-show="jira_key?.length" class="login-ico" style="position:absolute">
                              <svg class="ico-20" @click="showJiraKey = !showJiraKey">
                                <image class="icon-eye" v-show="showJiraKey" xlink:href="../../assets/icons/eye-slash.svg" width="20"
                                  height="20" />
                                  <image class="icon-eye" v-show="!showJiraKey" xlink:href="../../assets/icons/eye.svg" width="20"
                                  height="20" />
                              </svg>
                          </VueCustomTooltip>
                        </div>
                        <transition name="fade">
                          <label
                            v-if="
                              integrationJiraError && !$v.jira_key.minLength
                            "
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="integrationJiraError && !jira_key"
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório</label
                          >
                        </transition>
                        <small class="row"
                          ><font
                            v-text="$ml.with('Key').get('questionsAboutUrl')"
                          >
                            Dúvidas sobre Key ?</font
                          >
                          <a
                            class="ml-1"
                            href="https://support.atlassian.com/jira-software-cloud/docs/what-is-an-issue/#Workingwithissues-Projectandissuekeys"
                            target="_blank"
                            rel="noopener noreferrer"
                            v-text="$ml.get('clickHereToLearn')"
                          >
                            Saiba mais</a
                          >
                        </small>
                      </div>

                      <div class="mt-4">
                        <input
                          type="text"
                          v-model="jira_email"
                          class="form-control"
                          placeholder="my-email@domain.com"
                          maxlength="200"
                        />
                        <transition name="fade">
                          <label
                            v-if="
                              integrationJiraError && !$v.jira_email.minLength
                            "
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="integrationJiraError && !jira_email"
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório</label
                          >
                        </transition>
                        <small class="row"
                          ><font
                            v-text="$ml.with('Jira').get('yourAccesEmail')"
                          >
                            Seu e-mail de acesso ao Jira</font
                          >
                        </small>
                      </div>

                      <div class="mt-4">
                        <input
                          type="text"
                          v-model="jira_issue_type"
                          class="form-control"
                          placeholder="Task"
                          maxlength="100"
                        />
                        <transition name="fade">
                          <label
                            v-if="
                              integrationJiraError
                            "
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="integrationJiraError && !jira_issue_type"
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório</label
                          >
                        </transition>
                        <small class="row"
                          ><font
                            v-text="$ml.get('jiraIssueType')"
                          >
                            Qual será o tipo da atividade que será cadastrada no jira?</font
                          >
                        </small>
                      </div>

                      <div class="mt-4">
                        <div style="position: relative">
                          <input
                            :type="showJiraToken ? 'text' : 'password'"
                            v-model="jira_token"
                            class="form-control"
                            placeholder="21V21LwAbb3izVgdGmc177BH"
                            maxlength="400"
                          />
                          <VueCustomTooltip v-show="jira_token?.length" class="login-ico" style="position:absolute">
                              <svg class="ico-20" @click="showJiraToken = !showJiraToken">
                                <image class="icon-eye" v-show="showJiraToken" xlink:href="../../assets/icons/eye-slash.svg" width="20"
                                  height="20" />
                                  <image class="icon-eye" v-show="!showJiraToken" xlink:href="../../assets/icons/eye.svg" width="20"
                                  height="20" />
                              </svg>
                          </VueCustomTooltip>
                        </div>
                        <transition name="fade">
                          <label
                            v-if="
                              integrationJiraError && !$v.jira_token.minLength
                            "
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="integrationJiraError && !jira_token"
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório</label
                          >
                        </transition>
                        <small class="row"
                          ><font
                            v-text="$ml.with('Token').get('questionsAboutUrl')"
                          >
                            Dúvidas sobre token ?</font
                          >
                          <a
                            class="ml-1"
                            href="https://support.atlassian.com/atlassian-account/docs/manage-api-tokens-for-your-atlassian-account/"
                            target="_blank"
                            rel="noopener noreferrer"
                            v-text="$ml.get('clickHereToLearn')"
                          >
                            Saiba mais</a
                          >
                        </small>
                      </div>
                    </div>
                  </div>
                </div>

                <RecaptchaV2 ref="jira-recaptcha" @verify="setRecaptchaToken($event, 'jira-recaptcha')" @expired="tokenCaptcha['jira-recaptcha'] = ''" />

                <div class="row my-2">
                  <button
                    @click="alterIntegration('jira')"
                    class="btn btnForm m-0"
                    :disabled="!tokenCaptcha['jira-recaptcha']"
                  >
                    <img
                      v-show="loadingBtn"
                      src="../../../src/assets/icons/spinner.svg"
                      class="ico-17 fa-spin"
                    />
                    <span v-show="!loadingBtn" v-text="$ml.get('update')"
                      >Atualizar</span
                    >
                  </button>
                  <button
                    @click="removeIntegration('jira')"
                    :disabled="
                      !jira_url || !jira_key || !jira_email || !jira_token || !jira_issue_type || !tokenCaptcha['jira-recaptcha']
                    "
                    class="btn btn-outline-extra m-0 ml-2"
                  >
                    <Spinner v-show="loadingRemoveBtn" :color="'pink'" />
                    <span v-show="!loadingRemoveBtn" v-text="$ml.get('remove')"
                      >Remover</span
                    >
                  </button>
                </div>
              </form>
            </div>
          </b-collapse>
        </b-card>
        <!-- Zendesk -->
        <b-card no-body v-if="integrationList.includes('zendesk')" class="mb-2">
          <div class="card-header p-1" header-tag="header" role="tab">
            <h6
              block
              v-b-toggle.accordion-zendesk
              variant="info"
              class="p-2 light d-flex justify-content-between align-items-center"
            >
              <font>Zendesk</font>
              <span class="when-opened">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16 angle-right"
                />
              </span>
              <span class="when-closed">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16"
                />
              </span>
            </h6>
          </div>
          <b-collapse
            id="accordion-zendesk"
            visible
            accordion="my-accordion"
            role="tabpanel"
            @input="updateRecaptcha('zendesk')"
          >
            <div class="card-body">
              <form v-on:submit.prevent="">
                <div class="row">
                  <div class="col pr-1">
                    <div class="form-group">
                      <label class="text-muted">Zendesk Webhooks</label>

                      <div class="">
                        <input
                          type="text"
                          v-model="zendesk_url"
                          class="form-control"
                          placeholder="https://your-domain.zendesk.com/"
                          maxlength="200"
                        />
                        <transition name="fade">
                          <label
                            v-if="
                              integrationZendeskError &&
                              !$v.zendesk_url.minLength
                            "
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="integrationZendeskError && !zendesk_url"
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório</label
                          >
                        </transition>
                        <small class="row"
                          ><font
                            v-text="
                              $ml.with('url Zendesk').get('questionsAboutUrl')
                            "
                          >
                            Dúvidas sobre url Zendesk ?</font
                          >
                          <a
                            class="ml-1"
                            href="https://developer.zendesk.com/documentation/ticketing/getting-started/zendesk-api-quick-start/"
                            target="_blank"
                            rel="noopener noreferrer"
                            v-text="$ml.get('clickHereToLearn')"
                          >
                            Saiba mais</a
                          >
                        </small>
                      </div>

                      <div class="mt-4">
                        <input
                          type="text"
                          v-model="zendesk_email"
                          class="form-control"
                          placeholder="my-email@domain.com"
                          maxlength="100"
                        />
                        <transition name="fade">
                          <label
                            v-if="
                              integrationZendeskError &&
                              !$v.zendesk_email.minLength
                            "
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="
                              integrationZendeskError && !zendesk_email
                            "
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório</label
                          >
                        </transition>
                        <small class="row"
                          ><font
                            v-text="$ml.with('Zendesk').get('yourAccesEmail')"
                          >
                            Seu e-mail de acesso ao Zendesk</font
                          >
                        </small>
                      </div>

                      <div class="mt-4">
                        <div style="position: relative">
                          <input
                            :type="showZendeskToken ? 'text' : 'password'"
                            v-model="zendesk_token"
                            class="form-control"
                            placeholder="uBHwCeLqwfvX0TAECBIplEKASwFE20cxxvBbuuBH"
                            maxlength="45"
                          />
                          <VueCustomTooltip v-show="zendesk_token?.length" class="login-ico" style="position:absolute">
                              <svg class="ico-20" @click="showZendeskToken = !showZendeskToken">
                                <image class="icon-eye" v-show="showZendeskToken" xlink:href="../../assets/icons/eye-slash.svg" width="20"
                                  height="20" />
                                  <image class="icon-eye" v-show="!showZendeskToken" xlink:href="../../assets/icons/eye.svg" width="20"
                                  height="20" />
                              </svg>
                          </VueCustomTooltip>
                        </div>
                        <transition name="fade">
                          <label
                            v-if="
                              integrationZendeskError &&
                              !$v.zendesk_token.minLength
                            "
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="
                              integrationZendeskError && !zendesk_token
                            "
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório</label
                          >
                        </transition>
                        <small class="row"
                          ><font
                            v-text="$ml.with('Token').get('questionsAboutUrl')"
                          >
                            Dúvidas sobre token ?</font
                          >
                          <a
                            class="ml-1"
                            href="https://support.zendesk.com/hc/pt-br/articles/4408889192858-Gera%C3%A7%C3%A3o-de-novo-token-da-API"
                            target="_blank"
                            rel="noopener noreferrer"
                            v-text="$ml.get('clickHereToLearn')"
                          >
                            Saiba mais</a
                          >
                        </small>
                      </div>
                    </div>
                  </div>
                </div>

                <RecaptchaV2 ref="zendesk-recaptcha" @verify="setRecaptchaToken($event, 'zendesk-recaptcha')" @expired="tokenCaptcha['zendesk-recaptcha'] = ''" />

                <div class="row my-2">
                  <button
                    @click="alterIntegration('zendesk')"
                    class="btn btnForm m-0"
                    :disabled="!tokenCaptcha['zendesk-recaptcha']"
                  >
                    <img
                      v-show="loadingBtn"
                      src="../../../src/assets/icons/spinner.svg"
                      class="ico-17 fa-spin"
                    />
                    <span v-show="!loadingBtn" v-text="$ml.get('update')"
                      >Atualizar</span
                    >
                  </button>
                  <button
                    @click="removeIntegration('zendesk')"
                    :disabled="!zendesk_url || !zendesk_email || !zendesk_token || !tokenCaptcha['zendesk-recaptcha']"
                    class="btn btn-outline-extra m-0 ml-2"
                  >
                    <Spinner v-show="loadingRemoveBtn" :color="'pink'" />
                    <span v-show="!loadingRemoveBtn" v-text="$ml.get('remove')"
                      >Remover</span
                    >
                  </button>
                </div>
              </form>
            </div>
          </b-collapse>
        </b-card>
        <!-- Servicenow -->
        <b-card
          no-body
          v-if="integrationList.includes('servicenow')"
          class="mb-2"
        >
          <div class="card-header p-1" header-tag="header" role="tab">
            <h6
              block
              v-b-toggle.accordion-servicenow
              variant="info"
              class="p-2 light d-flex justify-content-between align-items-center"
            >
              <font>Servicenow</font>
              <span class="when-opened">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16 angle-right"
                />
              </span>
              <span class="when-closed">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16"
                />
              </span>
            </h6>
          </div>
          <b-collapse
            id="accordion-servicenow"
            visible
            accordion="my-accordion"
            role="tabpanel"
            @input="updateRecaptcha('servicenow')"
          >
            <div class="card-body">
              <form v-on:submit.prevent="">
                <div class="row">
                  <div class="col pr-1">
                    <div class="form-group">
                      <label class="text-muted">Servicenow Webhooks</label>

                      <div class="">
                        <input
                          type="text"
                          :disabled="servicenow_token ? true : false"
                          v-model="servicenow_url"
                          class="form-control"
                          placeholder="https://your-domain.service-now.com/"
                          maxlength="200"
                        />
                        <transition name="fade">
                          <label
                            v-if="
                              integrationServicenowError &&
                              !$v.servicenow_url.minLength
                            "
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="
                              integrationServicenowError && !servicenow_url
                            "
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório</label
                          >
                        </transition>
                        <small class="row"
                          ><font v-text="'Exemplo'"> </font>
                          <a
                            class="ml-1"
                            target="_blank"
                            rel="noopener noreferrer"
                            >https://your-domain.service-now.com</a
                          >
                        </small>
                      </div>

                      <div class="mt-4" v-if="servicenow_token">
                        <input
                          type="text"
                          :disabled="servicenow_token"
                          v-model="servicenow_token"
                          class="form-control"
                          placeholder="admin"
                          maxlength="100"
                        />
                        <small class="row">
                          <font v-text="'Token de integração servicenow!'">
                          </font>
                        </small>
                      </div>

                      <div class="mt-4" v-if="!servicenow_token">
                        <input
                          type="text"
                          v-model="servicenow_username"
                          class="form-control"
                          placeholder="User name"
                          maxlength="100"
                        />
                        <transition name="fade">
                          <label
                            v-if="
                              integrationServicenowError &&
                              !$v.servicenow_username.minLength
                            "
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="
                              integrationServicenowError && !servicenow_username
                            "
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório</label
                          >
                        </transition>
                      </div>

                      <div class="mt-4" v-if="!servicenow_token">
                        <div style="position: relative">
                          <input
                            :type="showSerivenowPassword ? 'text' : 'password'"
                            v-model="servicenow_password"
                            class="form-control"
                            placeholder="Password"
                            maxlength="45"
                          />
                          <VueCustomTooltip v-show="servicenow_password?.length" class="login-ico" style="position:absolute">
                              <svg class="ico-20" @click="showSerivenowPassword = !showSerivenowPassword">
                                <image class="icon-eye" v-show="showSerivenowPassword" xlink:href="../../assets/icons/eye-slash.svg" width="20"
                                  height="20" />
                                  <image class="icon-eye" v-show="!showSerivenowPassword" xlink:href="../../assets/icons/eye.svg" width="20"
                                  height="20" />
                              </svg>
                          </VueCustomTooltip>
                        </div>
                        <transition name="fade">
                          <label
                            v-if="
                              integrationServicenowError &&
                              !$v.servicenow_password.minLength
                            "
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="
                              integrationServicenowError && !servicenow_password
                            "
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório</label
                          >
                        </transition>
                      </div>
                    </div>
                  </div>
                </div>

                <RecaptchaV2 ref="servicenow-recaptcha" @verify="setRecaptchaToken($event, 'servicenow-recaptcha')" @expired="tokenCaptcha['servicenow-recaptcha'] = ''"/>

                <div class="row my-2">
                  <button
                    @click="alterIntegration('servicenow')"
                    class="btn btnForm m-0 mr-2"
                    :disabled="!tokenCaptcha['servicenow-recaptcha']"
                    v-if="!servicenow_token"
                  >
                    <img
                      v-show="loadingBtn"
                      src="../../../src/assets/icons/spinner.svg"
                      class="ico-17 fa-spin"
                    />
                    <span v-show="!loadingBtn" v-text="$ml.get('update')"
                      >Atualizar</span
                    >
                  </button>
                  <button
                    @click="removeIntegration('servicenow')"
                    :disabled="!servicenow_url || !tokenCaptcha['servicenow-recaptcha']"
                    class="btn btn-outline-extra m-0"
                  >
                    <Spinner v-show="loadingRemoveBtn" :color="'pink'" />
                    <span v-show="!loadingRemoveBtn" v-text="$ml.get('remove')"
                      >Remover</span
                    >
                  </button>
                </div>
              </form>
            </div>
          </b-collapse>
        </b-card>
        <!-- Trello -->
        <b-card no-body v-if="integrationList.includes('trello')" class="mb-2">
          <div class="card-header p-1" header-tag="header" role="tab">
            <h6
              block
              v-b-toggle.accordion-trello
              variant="info"
              class="p-2 light d-flex justify-content-between align-items-center"
            >
              <font>Trello</font>
              <span class="when-opened">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16 angle-right"
                />
              </span>
              <span class="when-closed">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16"
                />
              </span>
            </h6>
          </div>
          <b-collapse
            id="accordion-trello"
            visible
            accordion="my-accordion"
            role="tabpanel"
            @input="updateRecaptcha('trello')"
          >
            <div class="card-body">
              <form v-on:submit.prevent="">
                <div class="row">
                  <div class="col pr-1">
                    <div class="form-group">
                      <label class="text-muted">Trello Webhooks</label>

                      <div>
                        <div style="position: relative">
                          <input
                            :type="showTrelloKey ? 'text' : 'password'"
                            v-model="trello_key"
                            class="form-control"
                            placeholder="Key"
                            maxlength="200"
                          />
                          <VueCustomTooltip v-show="trello_key?.length" class="login-ico" style="position:absolute">
                              <svg class="ico-20" @click="showTrelloKey = !showTrelloKey">
                                <image class="icon-eye" v-show="showTrelloKey" xlink:href="../../assets/icons/eye-slash.svg" width="20"
                                  height="20" />
                                  <image class="icon-eye" v-show="!showTrelloKey" xlink:href="../../assets/icons/eye.svg" width="20"
                                  height="20" />
                              </svg>
                          </VueCustomTooltip>
                        </div>
                        <transition name="fade">
                          <label
                            v-if="
                              integrationTrelloError && !$v.trello_key.minLength
                            "
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="integrationTrelloError && !trello_key"
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório</label
                          >
                        </transition>
                        <small class="row">
                          <font
                            v-text="$ml.with('Key').get('questionsAboutUrl')"
                            >Dúvidas sobre Key ?</font
                          >
                          <a
                            class="ml-1"
                            href="https://developer.atlassian.com/cloud/trello/guides/rest-api/api-introduction/"
                            target="_blank"
                            rel="noopener noreferrer"
                            v-text="$ml.get('clickHereToLearn')"
                          >
                            Saiba mais</a
                          >
                        </small>
                      </div>

                      <div class="mt-4">
                        <div style="position: relative">
                          <input
                            :type="showTrelloToken ? 'text' : 'password'"
                            v-model="trello_token"
                            class="form-control"
                            placeholder="Token"
                            maxlength="100"
                          />
                          <VueCustomTooltip v-show="trello_token?.length" class="login-ico" style="position:absolute">
                              <svg class="ico-20" @click="showTrelloToken = !showTrelloToken">
                                <image class="icon-eye" v-show="showTrelloToken" xlink:href="../../assets/icons/eye-slash.svg" width="20"
                                  height="20" />
                                  <image class="icon-eye" v-show="!showTrelloToken" xlink:href="../../assets/icons/eye.svg" width="20"
                                  height="20" />
                              </svg>
                          </VueCustomTooltip>
                        </div>
                        <transition name="fade">
                          <label
                            v-if="
                              integrationTrelloError &&
                              !$v.trello_token.minLength
                            "
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="integrationTrelloError && !trello_token"
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório</label
                          >
                        </transition>
                        <small class="row">
                          <font
                            v-text="$ml.with('Token').get('questionsAboutUrl')"
                            >Dúvidas sobre Token ?</font
                          >
                          <a
                            class="ml-1"
                            href="https://developer.atlassian.com/cloud/trello/guides/rest-api/authorization/"
                            target="_blank"
                            rel="noopener noreferrer"
                            v-text="$ml.get('clickHereToLearn')"
                          >
                            Saiba mais</a
                          >
                        </small>
                      </div>
                    </div>
                  </div>
                </div>

                <RecaptchaV2 ref="trello-recaptcha" @verify="setRecaptchaToken($event, 'trello-recaptcha')" @expired="tokenCaptcha['trello-recaptcha'] = ''"/>

                <div class="row my-2">
                  <button
                    @click="alterIntegration('trello')"
                    class="btn btnForm m-0 mr-2"
                    :disabled="!tokenCaptcha['trello-recaptcha']"
                  >
                    <img
                      v-show="loadingBtn"
                      src="../../../src/assets/icons/spinner.svg"
                      class="ico-17 fa-spin"
                    />
                    <span v-show="!loadingBtn" v-text="$ml.get('update')"
                      >Atualizar</span
                    >
                  </button>
                  <button
                    @click="removeIntegration('trello')"
                    class="btn btn-outline-extra m-0"
                    :disabled="!tokenCaptcha['trello-recaptcha']"
                  >
                    <Spinner v-show="loadingRemoveBtn" :color="'pink'" />
                    <span v-show="!loadingRemoveBtn" v-text="$ml.get('remove')"
                      >Remover</span
                    >
                  </button>
                </div>
              </form>
            </div>
          </b-collapse>
        </b-card>
        <!-- Azure DevOps -->
        <b-card
          no-body
          v-if="integrationList.includes('azureDevOps')"
          class="mb-2"
        >
          <div class="card-header p-1" header-tag="header" role="tab">
            <h6
              block
              v-b-toggle.accordion-AzureDevOps
              variant="info"
              class="p-2 light d-flex justify-content-between align-items-center"
            >
              <font>Azure DevOps</font>
              <span class="when-opened">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16 angle-right"
                />
              </span>
              <span class="when-closed">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16"
                />
              </span>
            </h6>
          </div>
          <b-collapse
            id="accordion-AzureDevOps"
            visible
            accordion="my-accordion"
            role="tabpanel"
            @input="updateRecaptcha('azure')"
          >
            <div class="card-body">
              <form v-on:submit.prevent="">
                <div class="row">
                  <div class="col pr-1">
                    <div class="form-group">
                      <label class="text-muted">Azure DevOps Webhooks</label>

                      <div>
                        <input
                          type="text"
                          v-model="azureDevOps_organization"
                          class="form-control"
                          placeholder="Organization"
                          maxlength="200"
                        />
                        <transition name="fade">
                          <label
                            v-if="
                              integrationAzureDevOpsError &&
                              !$v.azureDevOps_organization.minLength
                            "
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="
                              integrationAzureDevOpsError &&
                              !azureDevOps_organization
                            "
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório</label
                          >
                        </transition>
                        <small class="row">
                          <font
                            v-text="
                              $ml.with('Organization').get('questionsAboutUrl')
                            "
                            >Dúvidas sobre Organization ?</font
                          >
                          <a
                            class="ml-1"
                            href="https://learn.microsoft.com/en-us/azure/devops/organizations/accounts/create-organization?view=azure-devops"
                            target="_blank"
                            rel="noopener noreferrer"
                            v-text="$ml.get('clickHereToLearn')"
                          >
                            Saiba mais</a
                          >
                        </small>
                      </div>

                      <div class="mt-4">
                        <input
                          type="text"
                          v-model="azureDevOps_project"
                          class="form-control"
                          placeholder="Project"
                          maxlength="200"
                        />
                        <transition name="fade">
                          <label
                            v-if="
                              integrationAzureDevOpsError &&
                              !$v.azureDevOps_project.minLength
                            "
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="
                              integrationAzureDevOpsError &&
                              !azureDevOps_project
                            "
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório</label
                          >
                        </transition>
                        <small class="row">
                          <font
                            v-text="
                              $ml.with('Project').get('questionsAboutUrl')
                            "
                            >Dúvidas sobre Project ?</font
                          >
                          <a
                            class="ml-1"
                            href="https://learn.microsoft.com/en-us/azure/devops/organizations/projects/about-projects?view=azure-devops"
                            target="_blank"
                            rel="noopener noreferrer"
                            v-text="$ml.get('clickHereToLearn')"
                          >
                            Saiba mais</a
                          >
                        </small>
                      </div>

                      <div class="mt-4">
                        <div style="position: relative">
                          <input
                            :type="showAzureToken ? 'text' : 'password'"
                            v-model="azureDevOps_token"
                            class="form-control"
                            placeholder="Token full access or Read & write Work Items"
                            maxlength="100"
                          />
                          <VueCustomTooltip v-show="azureDevOps_token?.length" class="login-ico" style="position:absolute">
                              <svg class="ico-20" @click="showAzureToken = !showAzureToken">
                                <image class="icon-eye" v-show="showAzureToken" xlink:href="../../assets/icons/eye-slash.svg" width="20"
                                  height="20" />
                                  <image class="icon-eye" v-show="!showAzureToken" xlink:href="../../assets/icons/eye.svg" width="20"
                                  height="20" />
                              </svg>
                          </VueCustomTooltip>
                        </div>
                        <transition name="fade">
                          <label
                            v-if="
                              integrationAzureDevOpsError &&
                              !$v.azureDevOps_token.minLength
                            "
                            class="lblError"
                            v-text="$ml.get('invalidData')"
                            >Dados inválidos</label
                          >
                          <label
                            v-else-if="
                              integrationAzureDevOpsError && !azureDevOps_token
                            "
                            class="lblError"
                            v-text="$ml.get('requiredField')"
                          >
                            Campo obrigatório</label
                          >
                        </transition>
                        <small class="row">
                          <font
                            v-text="$ml.with('Token').get('questionsAboutUrl')"
                            >Dúvidas sobre Token ?</font
                          >
                          <a
                            class="ml-1"
                            href="https://learn.microsoft.com/pt-br/azure/devops/organizations/accounts/use-personal-access-tokens-to-authenticate?view=azure-devops&tabs=Windows"
                            target="_blank"
                            rel="noopener noreferrer"
                            v-text="$ml.get('clickHereToLearn')"
                          >
                            Saiba mais</a
                          >
                        </small>
                      </div>
                    </div>
                  </div>
                </div>

                <RecaptchaV2 ref="azure-recaptcha" @verify="setRecaptchaToken($event, 'azure-recaptcha')" @expired="tokenCaptcha['azure-recaptcha'] = ''"/>

                <div class="row my-2">
                  <button
                    @click="alterIntegration('azureDevOps')"
                    class="btn btnForm m-0 mr-2"
                    :disabled="!tokenCaptcha['azure-recaptcha']"
                  >
                    <img
                      v-show="loadingBtn"
                      src="../../../src/assets/icons/spinner.svg"
                      class="ico-17 fa-spin"
                    />
                    <span v-show="!loadingBtn" v-text="$ml.get('update')"
                      >Atualizar</span
                    >
                  </button>
                  <button
                    @click="removeIntegration('azureDevOps')"
                    class="btn btn-outline-extra m-0"
                    :disabled="!tokenCaptcha['azure-recaptcha']"
                  >
                    <Spinner v-show="loadingRemoveBtn" :color="'pink'" />
                    <span v-show="!loadingRemoveBtn" v-text="$ml.get('remove')"
                      >Remover</span
                    >
                  </button>
                </div>
              </form>
            </div>
          </b-collapse>
        </b-card>
        <!-- External API -->
        <b-card no-body v-if="can_access_ext_api" class="mb-2">
          <div class="card-header p-1" header-tag="header" role="tab">
            <h6
              block
              v-b-toggle.accordion-ext-api
              variant="info"
              class="p-2 light d-flex justify-content-between align-items-center"
            >
              <font>External API</font>
              <span class="when-opened">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16 angle-right"
                />
              </span>
              <span class="when-closed">
                <img
                  src="../../assets/icons/angle-right_black.svg"
                  class="ico-16"
                />
              </span>
            </h6>
          </div>
          <b-collapse
            id="accordion-ext-api"
            visible
            accordion="my-accordion"
            role="tabpanel"
            @input="updateRecaptcha('external-api')"
          >
            <div class="card-body">
              <form v-on:submit.prevent="">
                <div class="row">
                  <div class="col pr-1">
                    <div class="form-group">
                      <label class="text-muted">API Token</label>
                      <div class="form-group">
                        <div style="position: relative">
                          <input :type="showApiToken ? 'text' : 'password'" class="form-control" v-model="apiToken"
                            name="password" :placeholder="$ml.get('placeholderTokenCompany')" />
                          <VueCustomTooltip v-show="apiToken?.length" class="login-ico" style="position:absolute">
                            <svg class="ico-20" @click="showApiToken = !showApiToken">
                              <image class="icon-eye" v-show="showApiToken" xlink:href="../../assets/icons/eye-slash.svg" width="20"
                                height="20" />
                                <image class="icon-eye" v-show="!showApiToken" xlink:href="../../assets/icons/eye.svg" width="20"
                                height="20" />
                            </svg>
                          </VueCustomTooltip>
                        </div>
                      </div>
                      <div>
                        <transition name="fade">
                          <label
                            v-if="tokenError"
                            class="lblError"
                            v-text="$ml.get('errorToken')"
                            >O token deve conter no mínimo 20 caracteres e no
                            máximo 500 caracteres!</label
                          >
                          >
                        </transition>
                      </div>
                    </div>
                  </div>
                </div>

                <RecaptchaV2 ref="external-api-recaptcha" @verify="setRecaptchaToken($event, 'external-api-recaptcha')" @expired="tokenCaptcha['external-api-recaptcha'] = ''" />

                <div class="row my-2">
                  <button :disabled="!tokenCaptcha['external-api-recaptcha'] && apiToken?.length" @click="alterIntegration('external-api')" class="btn btnForm">
                    <Spinner v-show="loadingBtn" />
                    <span v-show="!loadingBtn" v-text="$ml.get('update')"
                      >Atualizar</span
                    >
                  </button>
                  <button
                    @click="deleteCompanyToken()"
                    class="btn btn-outline-extra m-0 ml-2"
                    :disabled="!thereIsToken || !tokenCaptcha['external-api-recaptcha']"
                  >
                    <Spinner v-show="loadingRemoveBtn" :color="'pink'" />
                    <span v-show="!loadingRemoveBtn" v-text="$ml.get('remove')"
                      >Excluir</span
                    >
                  </button>
                </div>
              </form>
            </div>
          </b-collapse>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { minLength, required } from "vuelidate/lib/validators";
import RecaptchaV2 from "../../components/recaptchaV2.vue";
import CompanyService from "../../services/company.service";

export default {
  props: ["integrationList"],

  components: {
    RecaptchaV2,
  },
  data() {
    return {
      slack_url: "",
      teams_url: "",
      gChat_url: "",

      jira_url: "",
      jira_key: "",
      jira_email: "",
      jira_token: "",
      jira_issue_type: "",

      zendesk_url: "",
      zendesk_email: "",
      zendesk_token: "",

      servicenow_url: "",
      servicenow_token: "",
      servicenow_username: "",
      servicenow_password: "",

      gat_url: "",
      gat_token: "",
      selectedGatIntegration: { id: "all", name: "all" },
      gatIntegrationOpt: "",

      trello_key: "",
      trello_token: "",

      azureDevOps_organization: "",
      azureDevOps_project: "",
      azureDevOps_token: "",


      loadingBtn: false,
      loadingRemoveBtn: false,

      integrationGatError: false,
      integrationSlackError: false,
      integrationTeamsError: false,
      integrationGChatError: false,
      integrationJiraError: false,
      integrationZendeskError: false,
      integrationServicenowError: false,
      integrationTrelloError: false,
      integrationAzureDevOpsError: false,

      accordionSlack: null,

      apiToken: "",
      tokenError: false,
      thereIsToken: false,
      can_access_ext_api: "",

      showApiToken: false,
      showGatToken: false,
      showJiraKey: false,
      showJiraToken: false,
      showZendeskToken: false,
      showSerivenowPassword: false,
      showTrelloKey: false,
      showTrelloToken: false,
      showAzureToken: false,

      tokenCaptcha: {
        'gat-recaptcha': '',
        'slack-recaptcha': '',
        'teams-recaptcha': '',
        'google-chat-recaptcha': '',
        'jira-recaptcha': '',
        'zendesk-recaptcha': '',
        'servicenow-recaptcha': '',
        'trello-recaptcha': '',
        'azure-recaptcha': '',
        'external-api-recaptcha': '',
      }
    };
  },

  validations: {
    slack_url: { required, minLength: minLength(30) },
    teams_url: { required, minLength: minLength(30) },
    gChat_url: { required, minLength: minLength(30) },

    jira_url: { required, minLength: minLength(20) },
    jira_key: { required, minLength: minLength(2) },
    jira_email: { required, minLength: minLength(10) },
    jira_issue_type: { required, minLength: minLength(1) },
    jira_token: { required, minLength: minLength(10) },

    zendesk_url: { required, minLength: minLength(20) },
    zendesk_email: { required, minLength: minLength(10) },
    zendesk_token: { required, minLength: minLength(10) },

    servicenow_url: { required, minLength: minLength(20) },
    servicenow_username: { required, minLength: minLength(3) },
    servicenow_password: { required, minLength: minLength(3) },

    gat_url: { required, minLength: minLength(20) },
    gat_token: { required, minLength: minLength(10) },
    selectedGatIntegration: { required },

    trello_key: { required, minLength: minLength(10) },
    trello_token: { required, minLength: minLength(20) },

    azureDevOps_organization: { required, minLength: minLength(3) },
    azureDevOps_project: { required, minLength: minLength(3) },
    azureDevOps_token: { required, minLength: minLength(20) },
  },

  created() {
    this.changeIntegration();
  },
  mounted() {
    this.can_access_ext_api = this.$store.getters["getCanAcessExtApi"];
  },
  methods: {
    cleanCaptcha(integration){
      switch (integration) {
            case 'gat':
              this.$refs['gat-recaptcha'].resetRecaptcha();
              this.tokenCaptcha['gat-recaptcha'] = "";
              break;
            case 'slack':
              this.$refs['slack-recaptcha'].resetRecaptcha();
              this.tokenCaptcha['slack-recaptcha'] = "";
              break;
            case 'teams':
              this.$refs['teams-recaptcha'].resetRecaptcha();
              this.tokenCaptcha['teams-recaptcha'] = "";
              break;
            case 'google chat':
              this.$refs['google-chat-recaptcha'].resetRecaptcha();
              this.tokenCaptcha['google-chat-recaptcha'] = "";
              break;
            case 'jira':
              this.$refs['jira-recaptcha'].resetRecaptcha();
              this.tokenCaptcha['jira-recaptcha'] = "";
              break;
            case 'zendesk':
              this.$refs['zendesk-recaptcha'].resetRecaptcha();
              this.tokenCaptcha['zendesk-recaptcha'] = "";
              break;
            case 'servicenow':
              this.$refs['servicenow-recaptcha'].resetRecaptcha();
              this.tokenCaptcha['servicenow-recaptcha'] = "";
              break;
            case 'trello':
              this.$refs['trello-recaptcha'].resetRecaptcha();
              this.tokenCaptcha['trello-recaptcha'] = "";
              break;
            case 'azureDevOps':
              this.$refs['azure-recaptcha'].resetRecaptcha();
              this.tokenCaptcha['azure-recaptcha'] = "";
              break;
            case 'external-api':
              this.$refs['external-api-recaptcha'].resetRecaptcha();
              this.tokenCaptcha['external-api-recaptcha'] = "";
              break;
            default:
              console.log("Integration tool not found!");
          }
    },
    changeIntegration() {
      CompanyService.getCompanyIntegration().then((response) => {
        let resp = response.data;

        this.slack_url = resp.integration.webhook?.slack_url;
        this.teams_url = resp.integration.webhook?.teams_url;
        this.gChat_url = resp.integration.webhook?.gChat_url;

        this.jira_url = resp.integration.webhook?.jira?.url_jira ?? "";
        this.jira_key = resp.integration.webhook?.jira?.key ?? "";
        this.jira_email = resp.integration.webhook?.jira?.username ?? "";
        this.jira_issue_type = resp.integration.webhook?.jira?.issue_type ?? "Task";
        this.jira_token = resp.integration.webhook?.jira?.token ?? "";

        this.zendesk_url = resp.integration.webhook?.zendesk?.zendesk_url ?? "";
        this.zendesk_email = resp.integration.webhook?.zendesk?.username ?? "";
        this.zendesk_token = resp.integration.webhook?.zendesk?.token ?? "";

        this.servicenow_url =
          resp.integration.webhook?.servicenow?.url_servicenow ?? "";
        this.servicenow_token =
          resp.integration.webhook?.servicenow?.token ?? "";
        this.servicenow_username =
          resp.integration.webhook?.servicenow?.username ?? "";
        this.servicenow_password =
          resp.integration.webhook?.servicenow?.password ?? "";

        this.gat_url = resp.integration.webhook?.gat?.gat_url ?? "";
        this.gat_token = resp.integration.webhook?.gat?.token ?? "";
        this.selectedGatIntegration =
          resp.integration.webhook?.gat?.use_triage_tag == true
            ? { id: "gat-tag", name: "gat-tag" }
            : { id: "all", name: "all" };
        this.apiToken = resp?.integration.ext_token;
        this.thereIsToken = resp?.integration.ext_token ? true : false;
        this.trello_key = resp.integration.webhook?.trello?.key ?? "";
        this.trello_token = resp.integration.webhook?.trello?.token ?? "";

        this.azureDevOps_organization =
          resp.integration.webhook?.azureDevOps?.organization ?? "";
        this.azureDevOps_project =
          resp.integration.webhook?.azureDevOps?.project ?? "";
        this.azureDevOps_token =
          resp.integration.webhook?.azureDevOps?.token ?? "";
      });
    },

    async alterIntegration(integration) {
      var self = this;

      this.integrationGatError = false;
      this.integrationSlackError = false;
      this.integrationTeamsError = false;
      this.integrationGChatError = false;
      this.integrationJiraError = false;
      this.integrationZendeskError = false;
      this.integrationServicenowError = false;
      this.integrationTrelloError = false;
      this.integrationAzureDevOpsError = false;
      this.tokenError = false;

      // stop here if form is invalid
      this.$v.$touch();

      if (
        integration == "gat" &&
        (this.$v.gat_url.$invalid || this.$v.gat_token.$invalid)
      ) {
        this.integrationGatError = true;
        return;
      }

      if (integration == "slack" && this.$v.slack_url.$invalid) {
        this.integrationSlackError = true;
        return;
      }

      if (integration == "teams" && this.$v.teams_url.$invalid) {
        this.integrationTeamsError = true;
        return;
      }

      if (integration == "google chat" && this.$v.gChat_url.$invalid) {
        this.integrationGChatError = true;
        return;
      }

      if (
        integration == "jira" &&
        (this.$v.jira_url.$invalid ||
          this.$v.jira_key.$invalid ||
          this.$v.jira_email.$invalid ||
          this.$v.jira_issue_type.$invalid ||
          this.$v.jira_token.$invalid)
      ) {
        this.integrationJiraError = true;
        return;
      }

      if (
        integration == "zendesk" &&
        (this.$v.zendesk_url.$invalid ||
          this.$v.zendesk_email.$invalid ||
          this.$v.zendesk_token.$invalid)
      ) {
        this.integrationZendeskError = true;
        return;
      }

      if (
        integration == "servicenow" &&
        (this.$v.servicenow_url.$invalid ||
          this.$v.servicenow_username.$invalid ||
          this.$v.servicenow_password.$invalid)
      ) {
        this.integrationServicenowError = true;
        return;
      }

      if (
        integration == "trello" &&
        (this.$v.trello_key.$invalid || this.$v.trello_token.$invalid)
      ) {
        this.integrationTrelloError = true;
        return;
      }

      if (
        integration == "azureDevOps" &&
        (this.$v.azureDevOps_organization.$invalid ||
          this.$v.azureDevOps_project.$invalid ||
          this.$v.azureDevOps_project.$invalid)
      ) {
        this.integrationAzureDevOpsError = true;
        return;
      }

      this.loadingBtn = true;

      let payload = {};

      if (integration == "slack") {
        payload.slack_url = this.slack_url;
        payload.tokenRecaptcha = this.tokenCaptcha["slack-recaptcha"];
      }

      if (integration == "teams") {
        payload.teams_url = this.teams_url;
        payload.tokenRecaptcha = this.tokenCaptcha["teams-recaptcha"];
      }

      if (integration == "google chat") {
        payload.gChat_url = this.gChat_url;
        payload.tokenRecaptcha = this.tokenCaptcha["google-chat-recaptcha"];
      }

      if (integration == "jira") {
        payload.url_jira = this.jira_url;
        payload.key = this.jira_key;
        payload.username = this.jira_email;
        payload.issue_type = this.jira_issue_type;
        payload.token = this.jira_token;
        payload.tokenRecaptcha = this.tokenCaptcha["jira-recaptcha"];
      }

      if (integration == "zendesk") {
        payload.url_zendesk = this.zendesk_url;
        payload.username = this.zendesk_email;
        payload.token = this.zendesk_token;
        payload.tokenRecaptcha = this.tokenCaptcha["zendesk-recaptcha"];
      }

      if (integration == "servicenow") {
        payload.url_servicenow = this.servicenow_url;
        payload.username = this.servicenow_username;
        payload.password = this.servicenow_password;
        payload.tokenRecaptcha = this.tokenCaptcha["servicenow-recaptcha"];
      }

      if (integration == "gat") {
        payload.url_gat = this.gat_url;
        payload.token = this.gat_token;
        payload.use_triage_tag =
          this.selectedGatIntegration.id == "all" ? "no" : "yes";
        payload.tokenRecaptcha = this.tokenCaptcha["gat-recaptcha"];
      }
      if (integration == "external-api") {
        if(this.apiToken?.length < 20){
          this.tokenError = true;
          this.loadingBtn = false;
          return;
        }
        payload.ext_token = this.apiToken;
        payload.tokenRecaptcha = this.tokenCaptcha["external-api-recaptcha"];
      }

      if (integration == "trello") {
        payload.key = this.trello_key;
        payload.token = this.trello_token;
        payload.tokenRecaptcha = this.tokenCaptcha["trello-recaptcha"];
      }

      if (integration == "azureDevOps") {
        payload.organization = this.azureDevOps_organization;
        payload.project = this.azureDevOps_project;
        payload.token = this.azureDevOps_token;
        payload.tokenRecaptcha = this.tokenCaptcha["azure-recaptcha"];
      }

      payload.integration = integration;

      CompanyService.putCompanyIntegration(payload).then(
        (response) => {          
          this.updateRecaptcha(integration);

          if (response.data == "limit_exceeded") {
            self.verifyPlan();
            this.loadingBtn = false;
            return;
          }
          this.changeIntegration();
          Swal.fire({
            icon: "success",
            title: self.$ml.get("dataChanged"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
          this.loadingBtn = false;
          this.cleanCaptcha(integration);      
        },
        (error) => {
          this.cleanCaptcha(integration);      
          this.loadingBtn = false;

          if (error.response.data.message) {
            Swal.fire({
              icon: "warning",
              title: self.$ml
                .with(integration.toUpperCase())
                .get("invalidRegistrationData"),
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
            });
          } else {
            Swal.fire({
              icon: "warning",
              title: self.$ml.get("unableToCompleteThisRequest"),
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
            });
          }
        },
      );
    },

    async removeIntegration(integration) {
      var self = this;

      this.integrationGatError = false;
      this.integrationSlackError = false;
      this.integrationTeamsError = false;
      this.integrationGChatError = false;
      this.integrationJiraError = false;
      this.integrationZendeskError = false;
      this.integrationServicenowError = false;

      let payload = {};

      payload.tokenRecaptcha = this.tokenRecaptcha;
      if (integration == "slack") {
        payload.tokenRecaptcha = this.tokenCaptcha["slack-recaptcha"];
      }

      if (integration == "teams") {
        payload.tokenRecaptcha = this.tokenCaptcha["teams-recaptcha"];
      }

      if (integration == "google chat") {
        payload.tokenRecaptcha = this.tokenCaptcha["google-chat-recaptcha"];
      }

      if (integration == "jira") {
        payload.tokenRecaptcha = this.tokenCaptcha["jira-recaptcha"];
      }

      if (integration == "zendesk") {
        payload.tokenRecaptcha = this.tokenCaptcha["zendesk-recaptcha"];
      }

      if (integration == "servicenow") {
        payload.tokenRecaptcha = this.tokenCaptcha["servicenow-recaptcha"];
      }

      if (integration == "gat") {
        payload.tokenRecaptcha = this.tokenCaptcha["gat-recaptcha"];
      }
      if (integration == "external-api") {
        payload.tokenRecaptcha = this.tokenCaptcha["external-api-recaptcha"];
      }

      if (integration == "trello") {
        payload.tokenRecaptcha = this.tokenCaptcha["trello-recaptcha"];
      }

      if (integration == "azureDevOps") {
        payload.tokenRecaptcha = this.tokenCaptcha["azure-recaptcha"];
      }
      payload.integration = integration;

      Swal.fire({
        html: `<h4 class="m-2">${self.$ml
          .with(self.$ml.get("integration"))
          .get("doYouReallyWantToRemoveThis")}</h4>`,
        type: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        customClass: {
          cancelButton: 'btn-outline-extra',
        },
        confirmButtonText: self.$ml.get("remove"),
        cancelButtonText: self.$ml.get("cancel"),
      }).then((result) => {
        this.updateRecaptcha(integration);

        if (result.value) {
          self.loadingRemoveBtn = true;

          CompanyService.deleteCompanyIntegration(payload).then(
            (response) => {
              if (response.data == "limit_exceeded") {
                self.verifyPlan();
                this.loadingRemoveBtn = false;
                return;
              }
              this.changeIntegration();
              Swal.fire({
                icon: "success",
                title: self.$ml.get("removed"),
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              });
              this.loadingRemoveBtn = false;
              this.cleanCaptcha(integration);      
            },
            (error) => {
              this.cleanCaptcha(integration);      
              this.loadingRemoveBtn = false;

              if (error.response.data.message === 'Captcha does not authorize') {
                Swal.fire({
                  icon: "warning",
                  title: self.$ml.get("errorCaptcha"),
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 5000,
                });
              } else {
                Swal.fire({
                  icon: "warning",
                  title: self.$ml.get("unableToCompleteThisRequest"),
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 5000,
                });
              }
            },
          );
        }
      });
    },

    async verifyPlan() {
      var self = this;
      Swal.fire({
        icon: "info",
        html: `<h3 class="mb-2">${self.$ml.get("integrationsNotAvailable")}<h3> 
        <h5 class="mb-2">${self.$ml.get(
          "toAddTheseIntegrations",
        )} <a href="/account?plans">${self.$ml.get("here")}</a>  
        </h5>`,
        showConfirmButton: false,
        timer: 10000,
      });
    },
    deleteCompanyToken(){
      CompanyService.deleteCompanyToken({tokenCaptcha: this.tokenCaptcha['external-api-recaptcha']}).then((response) => {
        if (response.data === "token removido!") {
            Swal.fire({
                icon: "success",
                title: this.$ml.get("swalTokenRemoved"),
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              });
          this.apiToken = "";
          this.$refs['external-api-recaptcha'].resetRecaptcha();
          this.tokenCaptcha['external-api-recaptcha'] = "";
          this.changeIntegration();
      }
      }).catch((error) => {
        if (error.response.data.message === 'Captcha does not authorize') {
                Swal.fire({
                  icon: "warning",
                  title: self.$ml.get("errorCaptcha"),
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 5000,
                });
              }
      })
    },

    setRecaptchaToken(token, action) {
      this.tokenCaptcha[action] = token;
    },

    updateRecaptcha(integration) {
      const element = this.$refs[`${integration}-recaptcha`];

      if (element) {
        element.loadRecaptchaScript();
      }
    }
  },
};
</script>

<style scoped>
.lblError {
  position: relative;
}
.angle-right {
  -ms-transform: rotate(90deg); /* IE 9 */
  transform: rotate(90deg);
}

.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
.login-ico {
  position: absolute;
  right: 7px;
  top: 20%;
}
.icon-eye{
  width: 99%;
}
</style>
